var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinolexcatalouge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2945",
    "data-name": "Group 2945",
    transform: "translate(-95 -564)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 18,
    height: 18,
    rx: 3,
    transform: "translate(95 564)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 18,
    height: 18,
    rx: 3,
    transform: "translate(95 585)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 18,
    height: 18,
    rx: 3,
    transform: "translate(116 564)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    transform: "translate(116 585)",
    fill: "none",
    stroke: "#0094d9",
    strokeWidth: 2.75
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.375,
    y: 1.375,
    width: 15.25,
    height: 15.25,
    rx: 2.625,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinolexcatalouge);
export default __webpack_public_path__ + "static/media/finolexcatalouge.afe1dab3f4a751d5d64b57f1374f76a8.svg";
export { ForwardRef as ReactComponent };